module.exports = __webpack_public_path__ + "static/img/about_head.1642e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/about_head.png
// module id = +mK5
// module chunks = 1